<hau-form [formGroup]="form">
  <hau-form-field label="Name" cols="6" [validation]="form.validation.title">
    <input nbInput fullWidth formControlName="title">
  </hau-form-field>
  <hau-form-field label="Kategorie" cols="6" [validation]="form.validation.category">
    <input nbInput fullWidth formControlName="category" placeholder="z.B. Allgemein/Heizung">
  </hau-form-field>
  <hau-form-field label="Farbe" cols="12" [validation]="form.validation.color">
    <wr-color-preset-picker formControlName="color"></wr-color-preset-picker>
  </hau-form-field>
  <hau-form-field label="Beschreibung" cols="12" [validation]="form.validation.description">
    <textarea nbInput fullWidth formControlName="description"></textarea>
  </hau-form-field>

  <hau-form-field label="Felder" [validation]="form.validation.fields">
    <wr-custom-field-layout-editor formControlName="fields"></wr-custom-field-layout-editor>
  </hau-form-field>
</hau-form>
